import { serializeMention } from './tokens'
import type { MentionKind } from './types'

export type SerializableMention = {
  kind: string
  id: string
  display: string
}

export function serializeMentionsForSubmit(text: string, mentions: SerializableMention[]): string {
  if (mentions.length === 0) return text

  let result = text
  const sorted = [...mentions].sort((a, b) => b.display.length - a.display.length)
  for (const mention of sorted) {
    const displayForm = `@${mention.display}`
    const token = serializeMention(mention.kind as MentionKind, mention.id, mention.display)
    result = result.split(displayForm).join(token)
  }
  return result
}
